/** Match embedded converter / EditorShell sizing (keep placeholder in sync). */
export const embeddedConverterShellClassName =
  "flex min-h-0 flex-col overflow-hidden bg-zinc-100 text-zinc-950 h-[40rem] rounded-lg border border-zinc-200 md:h-[44rem]";
